import images from "../images";

const privacyData = [
  {
   yid: "privacy",
   path: "/privacy-policy",
   pageContent:{  
     PageBanner : {
       SubTitle : "See what's new",
       PageHeading : 'Privacy Policy',
       PageParagraph : "",
       validate:'false'
     },
       sectionData:[
         {
           SectionTitle: "Privacy Policy",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"",
               data:"This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.",
               list:[
                 {
                   item:""
                 },
                 {
                   item:""
                 }
               ]
             },{
               paraHeading:"",
               data:"We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.",
               list:[
                 {
                   item:""
                 },
                 {
                   item:""
                 }
               ]
             }
             
           ]
         },
         {
           SectionTitle: "Interpretation and Definitions",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"Interpretation",
               data:"The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
               list:[
                 {
                   item:""
                 },
                 {
                   item:""
                 }
               ]
             },{
               paraHeading:"Definitions",
               data:"For the purposes of this Privacy Policy:",
               list:[
                 {
                   item:"Account means a unique account created for You to access our Service or parts of our Service."
                 },
                 {
                   item:'Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.'
                 },
                 {
                   item:'Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Finsol Consultancy Pvt Ltd, SDF-1, SHED No.25 D, Phase-1, VSEZ, Duvvada, Visakhapatnam-530049.'
                 },
                 {
                   item:'Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.'
                 },
                 {
                   item:'Country refers to: Andhra Pradesh, India'
                 },
                 {
                   item:'Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.'
                 },
                 {
                   item:'Personal Data is any information that relates to an identified or identifiable individual.'
                 },
                 {
                   item:'Service refers to the Website.'
                 },
                 {
                   item:'Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.'
                 },
                 {
                   item:'Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).'
                 },
                 {
                   item:'Website refers to finsolconsultancy.com, accessible from https://vaidyo.vercel.app/'
                 },
                 {
                   item:'You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.'
                 }
               ]
             }
             
           ]
         },
         {
           SectionTitle: "Collecting and Using Your Personal Data",
           SubHeading:"Types of Data Collected",
           paragraph:[
             {
               paraHeading:"Personal Data",
               data:"While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:",
               list:[
                 {
                   item:"Email address"
                 },
                 {
                   item:"First name and last name"
                 },
                 {
                   item:"Phone number"
                 },
                 {
                   item:"Address, State, Province, ZIP/Postal code, City"
                 },
                 {
                   item:"Usage Data"
                 },
               ]
             },{
               paraHeading:"Usage Data",
               data:"Usage Data is collected automatically when using the Service.",
               list:[
                 {
                   item:"Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
                 },
                 {
                   item:"When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data."
                 },
                 {
                   item:"We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device."
                 }
               ]
             },
             {
               paraHeading:"Tracking Technologies and Cookies",
               data:"We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:",
               list:[
                 {
                   item:"•	Cookies or Browser Cookies. A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies."
                 },
                 {
                   item:"•	Web Beacons. Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity)."
                 },
                 {
                   item:'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies on the Privacy Policies website article.'                
                 }
               ]
             }
             
           ]
         },
         {
           SectionTitle: "",
           SubHeading:"We use both Session and Persistent Cookies for the purposes set out below:",
           paragraph:[
             {
               paraHeading:"Necessary / Essential Cookies",
               data:"",
               list:[
                 {
                   item:"Type: Session Cookies"
                 },
                 {
                   item:"Administered by: Us"
                 },
                 {
                   item:"Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services."
                 },
               ]
             },
             {
               paraHeading:"Cookies Policy / Notice Acceptance Cookies",
               data:"",
               list:[
                 {
                   item:"Type: Persistent Cookies"
                 },
                 {
                   item:"Administered by: Us"
                 },
                 {
                   item:"Purpose: These Cookies identify if users have accepted the use of cookies on the Website."
                 },
               ]
             },
             {
               paraHeading:"Functionality Cookies",
               data:"",
               list:[
                 {
                   item:"Type: Persistent Cookies"
                 },
                 {
                   item:"Administered by: Us"
                 },
                 {
                   item:"Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website."
                 },
                 {
                   item:"For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy."
                 }
               ]
             },
             {
               paraHeading:"Use of Your Personal Data",
               data:"The Company may use Personal Data for the following purposes:",
               list:[
                 {
                   item:"To provide and maintain our Service, including to monitor the usage of our Service."
                 },
                 {
                   item:"To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user."
                 },
                 {
                   item:"For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service."
                 },
                 {
                   item:" To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation."
                 },
                 {
                   item:'To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.'
                 },
                 {
                   item:'To manage Your requests: To attend and manage Your requests to Us.'
                 },
                 {
                   item:'For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.'
                 },
                 {
                   item:'For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.'
                 },
               ]
             },
             {
             
                 paraHeading:"",
                 data:"We may share Your personal information in the following situations:",
                 list:[
                   {
                     item:"•	With Service Providers: We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You."
                   },
                   {
                     item:"•	For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company."
                   },
                   {
                     item:"•	With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us."
                   },
                   {
                     item:"•	With business partners: We may share Your information with Our business partners to offer You certain products, services or promotions."
                   },
                   {
                     item:"•	With other users: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside."
                   },
                   {
                     item:"•	With Your consent: We may disclose Your personal information for any other purpose with Your consent."
                   }
                 ]
             },
             {
               paraHeading:"Retention of Your Personal Data",
               data:"The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.",
               list:[
                 {
                   item:""
                 },
               ]
             },
             {
               paraHeading:"",
               data:"The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.",
               list:[
                 {
                   item:""
                 },
               ]
             },
             {
               paraHeading:"Transfer of Your Personal Data",
               data:"Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.",
               list:[
                 {
                   item:"Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer."
                 },
                 {
                   item:"The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information."
                 },
               ]
             },
             {
               paraHeading:"Delete Your Personal Data",
               data:"",
               list:[
                 {
                   item:"You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You."
                 },
                 {
                   item:"Our Service may give You the ability to delete certain information about You from within the Service."
                 },
                 {
                   item:"You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us."
                 },
                 {
                   item:'Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.'
                 }
               ]
             },
           ]
         },
 
         {
           SectionTitle: "Disclosure of Your Personal Data",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"Business Transactions",
               data:"If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy. ",
               list:[
                 {
                   item:""
                 },
                 
               ]
             },{
               paraHeading:"Law enforcement",
               data:"Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).",
               list:[
                 {
                   item:""
                 },
                
               ]
             },
             {
               paraHeading:"Other legal requirements",
               data:"The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:",
               list:[
                 {
                   item:"•	Comply with a legal obligation"
                 },
                 {
                   item:"•	Protect and defend the rights or property of the Company"
                 },
                 {
                   item:"•	Prevent or investigate possible wrongdoing in connection with the Service"
                 },
                 {
                   item:'•	Protect the personal safety of Users of the Service or the public'
                 },
                 {
                   item:'•	Protect against legal liability'
                 }
                
               ]
             },
             {
               paraHeading:"Security of Your Personal Data",
               data:"The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.",
               list:[
                 {
                   item:""
                 },
               ]
             }
             
           ]
         },
         {
           SectionTitle: "Children's Privacy",
           SubHeading:"",
           paragraph:[
            
             {
               paraHeading:"",
               data:"Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers. If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information",
               list:[
                 {item:""}
               ]
             }
       ]
     },{
       SectionTitle: "Links to Other Websites",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"",
               data:" Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.",
               list:[
                 {
                   item:""
                 },
               ]
             },
           ]
     },
     {
       SectionTitle: "Changes to this Privacy Policy",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"",
               data:" ",
               list:[
                 {
                   item:"We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page."
                 },
                 {
                   item:'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.'
                 },
                 {
                   item:'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.'
                 }
               ]
             },
           ]
     },{
       SectionTitle: "Contact Us",
           SubHeading:"",
           paragraph:[
             {
               paraHeading:"",
               data:"If you have any questions about this Privacy Policy, You can contact us:",
               list:[
                 {
                   item:"•	By email: financeteam@finsolconsultancy.com"
                 },
                 
               ]
             },
           ]
     }
               
       ]
   }
  },
  {
    id: "refund",
    path: "/refund-policy",
    pageContent:{
      PageBanner : {
        SubTitle : "See what's new",
        PageHeading : ' Refund Policy',
        PageParagraph : "",
        validate:'false'
      },
        sectionData:[
          {
            SectionTitle: "Return and Refund Policy",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"Thank you for shopping at finsolconsultancy.com.",
                list:[
                  {
                    item:"If, for any reason, You are not completely satisfied with a purchase We invite You to review our policy on refunds and returns. This Return and Refund Policy has been created with the help of the Return and Refund Policy Generator."
                  },
                  {
                    item:"The following terms are applicable for any products that You purchased with Us."
                  },
                 ]
               }
             ]
           },
          {
            SectionTitle: "Interpretation and Definitions",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"Interpretation",
                data:"The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"Definitions",
                data:"For the purposes of this Return and Refund Policy:",
                list:[
                  {
                    item:'Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Finsol Consultancy Pvt Ltd, SDF-1, SHED NO.25 D, Phase-1, VSEZ, Duvvada, Visakhapatnam-530049.'
                  },
                  {
                    item:"Goods refer to the items offered for sale on the Service."
                  },
                  {
                    item:'Orders mean a request by You to purchase Goods from Us.'
                  },
                  {
                    item:'Service refers to the Website.'
                  },
                  {
                    item:'Website refers to finsolconsultancy.com, accessible from https://vaidyo.vercel.app/'
                  },
                  {
                    item:'You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.'
                  },
                 ]
               },
             ]
           },
          {
            SectionTitle: "Your Order Cancellation Rights",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"You are entitled to cancel Your Order within 30 days without giving any reason for doing so.",
                list:[
                  {
                    item:"The deadline for cancelling an Order is 30 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered."
                  },
                  {
                    item:"In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:"
                  },
                  {
                    item:"•	By email: financeteam@finsolconsultancy.com"
                  },
                  {
                    item:"We will reimburse You no later than 14 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement."
                  }
                 ]
               },
             ]
           },
          {
            SectionTitle: "Conditions for Returns",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"In order for the Goods to be eligible for a return, please make sure that:",
                list:[
                  {
                    item:"•	The Goods were purchased in the last 14 days"
                  },
                  {
                    item:"•	The Goods are in the original packaging."
                  },
                 
                 ]
               },
              {
                paraHeading:"",
                data:"The following Goods cannot be returned:",
                list:[
                  {
                    item:"•	The supply of Goods made to Your specifications or clearly personalized."
                  },
                  {
                    item:"•	The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over."
                  },
                  {
                    item:"•	The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery."
                  },
                  {
                    item:"•	The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items."
                  },
                 
                 ]
               },
              {
                paraHeading:"",
                data:"We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion.",
                list:[
                  {
                    item:""
                  },
                 
                 ]
               },
              {
                paraHeading:"",
                data:"Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.",
                list:[
                  {
                    item:""
                  },
                 
                 ]
               },
             ]
           },
           {
            SectionTitle: "Returning Goods",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods at the following address:",
                list:[
                  {
                    item:""
                  },
                ]
              },
              {
                paraHeading:"",
                data:"SDF-1,SHED NO.25 D, Phase-1, VSEZ, Duvvada, Visakhapatnam",
                list:[
                  {
                    item:""
                  },
                ]
              },
              {
                paraHeading:"",
                data:"We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.",
                list:[
                  {
                    item:""
                  },
                ]
              },
              {
                paraHeading:"Contact Us",
                data:"If you have any questions about our Returns and Refunds Policy, please contact us:",
                list:[
                  {
                    item:"•	By email: financeteam@finsolconsultancy.com"
                  },
                ]
              },
            ]
          }
         ]
    }
  },
  {
    id: "terms and conditions",
    path: "/terms&conditions",
    pageContent:{
      PageBanner : {
        SubTitle : "See what's new",
        PageHeading : 'Terms and Conditions',
        PageParagraph : "Please read these terms and conditions carefully before using Our Service.",
        validate:'false'
      },
        sectionData:[
          {
            SectionTitle: "Interpretation and Definitions",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"Interpretation",
                data:"The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"Definitions",
                data:"For the purposes of these Terms and Conditions:",
                list:[
                  {
                    item:'Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.'
                  },
                  {
                    item:"Country refers to: Andhra Pradesh, India"
                  },
                  {
                    item:'Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to FINSOL CONSULTANCY PRIVATE LIMITED, SDF-1, SHED NO.25 D, Phase-1, VSEZ, Duvvada, Visakhapatnam - 530049.'
                  },
                  {
                    item:'Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.'
                  },
                  {
                    item:'Service refers to the Website.'
                  },
                  {
                    item:'Terms and Conditions (also referred as "Terms") mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service. This Terms and Conditions agreement has been created with the help of the Terms and Conditions Generator.'
                  },
                  {
                    item:'Third-party Social Media Service means any services or content (including data, information, products or services) provided by a third-party that may be displayed, included or made available by the Service.'
                  },
                  {
                    item:'Website refers to finsolconsultancy.com, accessible from https://vaidyo.vercel.app/'
                  },
                  {
                    item:'You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.'
                  },
                 ]
               },
             ]
           },
           {
            SectionTitle: "Acknowledgment",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"",
                list:[
                  {
                    item:"These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service."
                  },
                  {
                    item:"Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service."
                  },
                  {
                    item:"By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service."
                  },
                  {
                    item:"You represent that you are over the age of 18. The Company does not permit those under 18 to use the Service."
                  },
                  {
                    item:"Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal information when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service."
                  },
                 ]
               },
              ]
            
           },
           {
            SectionTitle: "Links to Other Websites",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"",
                list:[
                  {
                    item:"Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company."
                  },
                  {
                    item:"The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services"
                  },
                  {
                    item:"We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or services that You visit."
                  },
                 
                 ]
               },
              ]
            
           },
           {
            SectionTitle: "Termination",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.",
                list:[
                  {
                    item:"Upon termination, Your right to use the Service will cease immediately."
                  },
                 ]
               },
              ]
           },
           {
            SectionTitle: "Limitation of Liability",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service or 100 USD if You haven't purchased anything through the Service.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"",
                data:"To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"",
                data:"Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party's liability will be limited to the greatest extent permitted by law.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              ]
           },
           {
            SectionTitle: '"AS IS" and "AS AVAILABLE" Disclaimer',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet Your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"",
                data:"Without limiting the foregoing, neither the Company nor any of the company's provider makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the Service, or the information, content, and materials or products included thereon; (ii) that the Service will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any information or content provided through the Service; or (iv) that the Service, its servers, the content, or e-mails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"",
                data:'Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent enforceable under applicable law.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
              ]
           },
           {
            SectionTitle: 'Governing Law',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
             
              ]
           },
           {
            SectionTitle: 'Disputes Resolution',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting the Company.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
             
              ]
           },
           {
            SectionTitle: 'Severability and Waiver',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"Severability",
                data:'If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"Waiver",
                data:"Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
             
              ]
           },
           {
            SectionTitle: 'Translation Interpretation',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'These Terms and Conditions may have been translated if We have made them available to You on our Service. You agree that the original English text shall prevail in the case of a dispute.',
                list:[
                  {
                    item:""
                  },
                 ]
               },
              ]
           },
           {
            SectionTitle: 'Changes to These Terms and Conditions',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"",
                data:"By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              ]
           },
           {
            SectionTitle: 'Contact Us',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"If you have any questions about these Terms and Conditions, You can contact us:",
                list:[
                  {
                    item:"•	By email: financeteam@finsolconsultancy.com"
                  },
                 ]
               },
              ]
           },
         ]
    }
  },
  {
    id: "disclaimer",
    path: "/disclaimer",
    pageContent:{
      PageBanner : {
        SubTitle : "See what's new",
        PageHeading : 'Disclaimer',
        PageParagraph : "",
        validate:'false'
      },
        sectionData:[
          {
            SectionTitle: "Interpretation and Definitions",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"Interpretation",
                data:"The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
                list:[
                  {
                    item:""
                  },
                 ]
               },
              {
                paraHeading:"Definitions",
                data:"For the purposes of this Disclaimer:",
                list:[
                  {
                    item:'Company (referred to as either "the Company", "We", "Us" or "Our" in this Disclaimer) refers to finsol consultancy pvt ltd, SDF-1, SHED NO.25, Phase-1, VSEZ, Duvvada, Visakhapatnam - 530049.'
                  },
                  {
                    item:"Service refers to the Website."
                  },
                  {
                    item:'You means the individual accessing the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.'
                  },
                  {
                    item:'Website refers to finsolconsultancy.com, accessible from https://vaidyo.vercel.app/'
                  },
                 
                 ]
               },
             ]
           },
          {
            SectionTitle: "Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"",
                list:[
                  {
                    item:"The information contained on the Service is for general information purposes only."
                  },
                  {
                    item:'The Company assumes no responsibility for errors or omissions in the contents of the Service.'
                  },
                  {
                    item:'In no event shall the Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice. This Disclaimer has been created with the help of the Disclaimer Generator.'
                  },
                  {
                    item:'The Company does not warrant that the Service is free of viruses or other harmful components.'
                  },
                 ]
               },
           
             ]
           },
          {
            SectionTitle: "External Links Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"",
                list:[
                  {
                    item:"The Service may contain links to external websites that are not provided or maintained by or in any way affiliated with the Company."
                  },
                  {
                    item:'Please note that the Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.'
                  },
                  
                 ]
               },
           
             ]
           },
          {
            SectionTitle: "Errors and Omissions Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"The information given by the Service is for general guidance on matters of interest only. Even if the Company takes every precaution to ensure that the content of the Service is both current and accurate, errors can occur. Plus, given the changing nature of laws, rules and regulations, there may be delays, omissions or inaccuracies in the information contained on the Service.",
                list:[
                  {
                    item:""
                  },   
                 ]
               },
              {
                paraHeading:"",
                data:"The Company is not responsible for any errors or omissions, or for the results obtained from the use of this information.",
                list:[
                  {
                    item:""
                  },   
                 ]
               },
           
             ]
           },
          {
            SectionTitle: "Fair Use Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"",
                list:[
                  {
                    item:"The Company may use copyrighted material which has not always been specifically authorized by the copyright owner. The Company is making such material available for criticism, comment, news reporting, teaching, scholarship, or research."
                  },   
                  {
                    item:'The Company believes this constitutes a "fair use" of any such copyrighted material as provided for in section 107 of the United States Copyright law.'
                  },   
                  {
                    item:'If You wish to use copyrighted material from the Service for your own purposes that go beyond fair use, You must obtain permission from the copyright owner.'
                  },   
                 ]
               },
             ]
           },
          {
            SectionTitle: "Views Expressed Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"The Service may contain views and opinions which are those of the authors and do not necessarily reflect the official policy or position of any other author, agency, organization, employer or company, including the Company.",
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
              {
                paraHeading:"",
                data:"Comments published by users are their sole responsibility and the users will take full responsibility, liability and blame for any libel or litigation that results from something written in or as a direct result of something written in a comment. The Company is not liable for any comment published by users and reserves the right to delete any comment for any reason whatsoever.",
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
             ]
           },
          {
            SectionTitle: "No Responsibility Disclaimer",
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:"The information on the Service is provided with the understanding that the Company is not herein engaged in rendering legal, accounting, tax, or other professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal or other competent advisers.",
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
              {
                paraHeading:"",
                data:"In no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Service.",
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
             ]
           },
          {
            SectionTitle: '"Use at Your Own Risk" Disclaimer',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'All information in the Service is provided "as is", with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind, express or implied, including, but not limited to warranties of performance, merchantability and fitness for a particular purpose.',
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
              {
                paraHeading:"",
                data:"The Company will not be liable to You or anyone else for any decision made or action taken in reliance on the information given by the Service or for any consequential, special or similar damages, even if advised of the possibility of such damages.",
                list:[
                  {
                    item:""
                  },   
                     
                 ]
               },
             ]
           },
          {
            SectionTitle: 'Contact Us',
            SubHeading:"",
            paragraph:[
              {
                paraHeading:"",
                data:'If you have any questions about this Disclaimer, You can contact Us:',
                list:[
                  {
                    item:"•	By email: financeteam@finsolconsultancy.com"
                  },   
                     
                 ]
               },
             
             ]
           },
         ]
    }
  },
]
export default privacyData;
